const listPublisherForProduction = [
  {
    id: 143,
    url: "https://senfnews.com",
    categories: ["رسانه"],
  },
  {
    id: 1,
    url: "https://monirlock.ir",
    categories: ["یراق آلات ساختمانی"],
  },
  {
    id: 84,
    url: "https://jobs-info.ir",
    categories: ["رسانه"],
  },
  {
    id: 209,
    url: "http://rubitools.ir",
    categories: ["ابزارآلات"],
  },
  {
    id: 61,
    url: "https://www.entes.ir",
    categories: ["تجهیزات الکتریکی"],
  },
  {
    id: 237,
    url: "https://eimeni.ir",
    categories: ["یراق آلات ساختمانی"],
  },
  {
    id: 214,
    url: "https://solga.ir",
    categories: ["ابزارآلات"],
  },
  {
    id: 194,
    url: "https://berico.ir",
    categories: ["چسب و روان کننده ها"],
  },
  {
    id: 201,
    url: "https://www.fiorigroup.ir",
    categories: ["ماشین آلات صنعتی و راه سازی"],
  },
  {
    id: 195,
    url: "https://bullhead.ir",
    categories: ["پیچ و مهره و اتصالات", "ابزارآلات"],
  },
  {
    id: 137,
    url: "https://rullplug.ir",
    categories: ["ادوات نصب"],
  },
  {
    id: 123,
    url: "https://riverstone.ir",
    categories: ["یراق آلات ساختمانی"],
  },
  {
    id: 118,
    url: "https://paatlock.ir",
    categories: ["یراق آلات ساختمانی"],
  },
  {
    id: 99,
    url: "https://baradaran-hinge.ir",
    categories: ["یراق آلات ساختمانی"],
  },
  {
    id: 63,
    url: "https://www.ezcurra.ir",
    categories: ["یراق آلات ساختمانی"],
  },
  {
    id: 20,
    url: "https://bestig.ir",
    categories: ["ابزارآلات"],
  },
  {
    id: 172,
    url: "https://wd-40.ir",
    categories: ["چسب و روان کننده ها"],
  },
  {
    id: 153,
    url: "https://sista.ir",
    categories: ["چسب و روان کننده ها"],
  },
];
const listPublisherForDevelopment = [
  {
    id: 250,
    url: "https://batmatic-test.ir",
    categories: ["ماشین آلات صنعتی و راه سازی","پیچ و مهره و اتصالات"],
  },
  {
    id: 251,
    url: "https://barikell-test.ir",
    categories: ["ماشین آلات صنعتی و راه سازی","پیچ و مهره و اتصالات"],
  },
  {
    id: 253,
    url: "https://lola-baradaran-test.ir",
    categories: ["یراق آلات ساختمانی"],
  },
  {
    id: 254,
    url: "https://sepehr-steel-test.ir",
    categories: ["یراق آلات ساختمانی"],
  },
  {
    id: 261,
    url: "https://rubitools-test.ir",
    categories: ["ابزارآلات"],
  },
  {
    id: 262,
    url: "https://felotools-test.ir",
    categories: ["ابزارآلات"],
  },
  {
    id: 263,
    url: "https://concordtools-test.ir",
    categories: ["ابزارآلات"],
  },
  {
    id: 8,
    url: "https://concordtools-test.ir",
    categories: ["ابزارآلات"],
  } 
];

const getSitePublisher = () => {
  if (process.env.REACT_APP_STATE == "PRODUCTION") {
    return listPublisherForProduction;
  }
  return listPublisherForDevelopment;
};

export default getSitePublisher();
